import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/background.mp3")